import { useBotIconStore } from 'Store/bot-icon'
import { useSettingsStore } from 'Store/settings'

export function setDefaultIconPosition(isFullScreen) {
  const settingsStore = useSettingsStore()
  const settings = settingsStore.getSettings
  if (isFullScreen) {
    _setPositions(
      settings.mobile_position_bottom,
      settings.mobile_position_right,
      settings.icon_size_mobile
    )
  } else {
    _setPositions(settings.pc_position_bottom, settings.pc_position_right, settings.icon_size_pc)
  }
}

function _setPositions(iconBottom, iconRight, iconSize) {
  const botIconStore = useBotIconStore()

  botIconStore.setBotIconBottom(iconBottom)
  botIconStore.setBotIconRight(iconRight)
}
